/* eslint-disable max-len */
import React from 'react';

interface ReportsIconProps {
    isActive?: boolean;
}

const ReportsIcon: React.FC<ReportsIconProps> = ({ isActive = false }) => {

    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.93652 0.557617C12.3295 0.979955 15.02 3.67053 15.4424 7.06348C15.4683 7.27161 15.2952 7.5 15 7.5H9C8.72386 7.5 8.5 7.27614 8.5 7V1L8.50977 0.895508C8.55614 0.664791 8.75431 0.534941 8.93652 0.557617Z"
                stroke="currentColor"
                fill={isActive ? 'currentColor' : 'none'}
            />
            <path
                d="M15.2444 9.94145C14.9037 11.2131 14.2342 12.3727 13.3033 13.3036C12.3724 14.2345 11.2128 14.904 9.94114 15.2447C8.66948 15.5855 7.33052 15.5855 6.05886 15.2447C4.78719 14.904 3.62762 14.2345 2.6967 13.3036C1.76578 12.3727 1.0963 11.2131 0.755556 9.94145C0.414815 8.66978 0.414815 7.33083 0.755556 6.05916C1.0963 4.78749 1.76578 3.62793 2.6967 2.697C3.62762 1.76608 4.78719 1.0966 6.05886 0.755859"
                stroke="currentColor"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default ReportsIcon;